module.exports = __webpack_public_path__ + "static/down.deed70d7.svg";